// import React, { createContext, useState } from 'react';

// const AuthContext = createContext();

// const AuthProvider = ({ children }) => {
//     const [user, setUser] = useState(null);

//     const login = (userData) => {
//         setUser(userData);
//     };

//     const logout = () => {
//         setUser(null);
//     };

//     return (
//         <AuthContext.Provider value={{ user, login, logout }}>
//             {children}
//         </AuthContext.Provider>
//     );
// };

// export { AuthContext, AuthProvider };

/****************************************************************************** */
import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // Load user from localStorage on app start
  useEffect(() => {
    const savedUser = localStorage.getItem("appUser");
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  // Simulate login (mock auth)
  const login = (identifier, password) => {
    if (!identifier) return false;

    // You can add validation logic here
    const mockUser = {
      name: identifier.includes("@") ? identifier.split("@")[0] : `User${identifier}`,
      email: identifier.includes("@") ? identifier : `${identifier}@mockmail.com`,
      token: "mock-token-123",
    };

    setUser(mockUser);
    localStorage.setItem("appUser", JSON.stringify(mockUser));
    return true;
  };

  // Simulate logout
  const logout = () => {
    setUser(null);
    localStorage.removeItem("appUser");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
